<template>
  <ModuleSection title="新币种账户申请-信息确认"  >
  <el-row class="account-opening-detail-container">

  <el-col v-for="(item, index) in fields" :key="item.key" :span="12">
    <div :class="['item', index % 2 === 0 ? 'even' : 'odd']">
      <label>{{ $t(item.label)}}</label>
      <span>{{ item.formatter ?  $t(item.formatter(fieldsData[item.field])) : fieldsData[item.field] }}</span>
    </div>
  </el-col>
  </el-row>
  <div style="margin-top: 40px">
    <el-button style="width:140px" type="primary" @click="confirm()">{{ $t('确定') }}</el-button>
    <el-button style="width:140px" type="info" @click="$router.go(-1)">{{ $t('上一步') }}</el-button>
  </div>
  </ModuleSection>
</template>

<script>
/* eslint-disable camelcase */
import ModuleSection from '@/components/container/ModuleSection'
import { getSignDataByObj } from '@/utils/USBKeyUtil'
import { addOpenApply } from '../api/electronic-account-opening'
import Vue from 'vue'
import { mapState } from 'vuex'
export default {
  name: 'ElectronicAccountOpeningConfirm',
  created () {
    this.fieldsData = this.$route.query
  },
  components: {
    ModuleSection
  },
  data () {
    const { $_params } = this
    return {
      fields: [
        {
          label: '核心客户号',
          field: 'custId'
        },
        {
          label: '企业名称',
          field: 'custName'
        },
        {
          label: '币种',
          field: 'currencyType',
          formatter (value) {
            return $_params.getDisplay.call(Vue.prototype, 'GRB_CURRENCY_TYPE', value)
          }
        },
        {
          label: '账户类型',
          field: 'accountType',
          formatter (value) {
            return $_params.getDisplay.call(Vue.prototype, 'CB_ACCOUNT_TYPE', value)
          }
        },
        {
          label: '账户别名',
          field: 'aliasName'
        }
      ],
      fieldsData: {}
    }
  },
  computed: {
    ...mapState('login', ['loginInfo'])
  },
  methods: {

    signCheck () {
    // 交易名称#transferName|企业名称#custName|币种#currencyType
      const { custName, currencyType } = this.$route.query
      const { customerId, userId } = this.loginInfo
      const info = {
        obviousInfo: {
          交易名称: '新币种账户申请',
          企业名称: custName,
          币种: currencyType
        },
        hiddenInfo: {
          客户号: customerId,
          用户编号: userId,
          交易代码: '10101234'
        },
        showHiddenColon: true
      }
      return new Promise((resolve, reject) => {
        getSignDataByObj.call(this, info, (signData) => {
          resolve(signData)
        })
      })
    },
    confirm () {
      const { currencyType, custName, accountType, aliasName } = this.$route.query
      const { customerId, userId } = this.loginInfo
      this.signCheck().then(signData => {
        // 由于改调用庐山申请，accountType需要转化为庐山的类型值
        // 目前只有标准账户
        const accountTypeMap = {
          '00': 'STANDARD', // 标准账户
          MSBC: 'B2B', // B2B
          MSBD: 'MKT_PLC' // 电商
        }
        addOpenApply({
          signData,
          custName,
          accountType: accountTypeMap[accountType],
          aliasName,
          currentBusinessCode: '10101234',
          businessCode: '10101234',
          currencyType,
          transferName: '新币种账户申请',
          logRecordFlag: '1',
          session_customerId: customerId,
          session_userId: userId
        }).then(res => {
          this.$router.push({
            name: 'ElectronicAccountOpeningResult',
            query: res
          })
        }).catch(console.error)
      }).catch(console.error)
    }
  }
}
</script>

<style lang="less" scoped>
.account-opening-detail-container {
  box-shadow: 0px 6px 20px 0px rgba(90, 96, 127, 0.1);
  border-radius: 10px;
  border: 1px solid #F6F7FC;
  .item {
    // border: 1px solid red;
    display: flex;
    height: 60px;
    align-items: center;
    width: 100%;
    >label {
      // border: 1px solid green;
      padding-left: 60px;
      width: 50%;
      color: #333752;
      font-size: 14;
      font-weight: 400;
    }
    >span {
      color: #5A607F;
      padding-left: 60px;
      font-size: 14px;
      font-weight: 300px;
    }
  }
  .even {
    border-bottom: 1px solid #F6F7FC;
    border-right: 1px solid #F6F7FC;
  }
  .odd {
    border-bottom: 1px solid #F6F7FC;
  }
}
</style>
